import mathUtils from './mathUtils';

// xorshift
const MAX = 2 ** 32;

const assertValidSeed = (seed) => {
  if (isNaN(seed) || parseInt(seed, 10) !== seed || seed <= 0 || seed >= MAX) {
    throw Error(`Invalid seed ${seed}`);
  }
};

class Rng {
  constructor(seed) {
    if (seed !== undefined) {
      assertValidSeed(seed);
    }
    this.seed = seed || 1;
  }

  next() {
    let next = this.seed;
    next ^= next << 13;
    next ^= next >> 17;
    next ^= next << 5;
    next = next < 0 ? MAX + next : next;
    this.seed = next;
    return next;
  }

  float(low, high) {
    const next = this.next() / MAX;
    return low + next * (high - low);
  }

  int(low, high) {
    return Math.floor(this.float(low, high));
  }

  // with replacement
  inds(n, m, options) {
    const { weight } = options;
    const res = [];
    if (!weight) {
      for (let i = 0; i < m; i++) {
        res.push(this.int(0, n));
      }
    } else {
      if (weight.length !== n) {
        throw Error(`Cannot weight ${n} elements by vector of length ${weight.length}`);
      }
      const cumsum = mathUtils.cumsum(weight);
      const totalProb = cumsum[n - 1];
      for (let i = 0; i < m; i++) {
        const r = this.float(0, totalProb);
        let j = 0;
        while (j < n && cumsum[j] < r) {
          j++;
        }
        res.push(j);
      }
    }
    return res;
  }

  // without replacement
  choice(arr, n) {
    const overrides = {};
    const result = [];

    const get = (i) => {
      let x = overrides[i];
      if (x === undefined) {
        x = arr[i];
      }
      return x;
    };

    for (let i = 0; i < n; i++) {
      const idx = this.int(0, arr.length);
      const elem = get(idx);
      overrides[idx] = get(i);
      overrides[i] = elem;
      result.push(elem);
    }
    return result;
  }

  singleChoice(arr) {
    return this.choice(arr, 1)[0];
  }
}

const seedToHex = (seed) => {
  assertValidSeed(seed);
  return seed.toString(16);
};

const hexToSeed = (hex) => {
  const seed = parseInt(hex, 16);
  assertValidSeed(seed);
  return seed;
};

const randomSeed = () => {
  return Math.floor(1 + Math.random() * (2 ** 32 - 1));
};

export default {
  Rng,
  seedToHex,
  hexToSeed,
  randomSeed,
};



// WEBPACK FOOTER //
// src/core/random.js